import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type DsSkeletonVariant = 'title' | 'text' | 'card' | 'icon' | 'avatar' | 'image';

@Component({
  selector: 'ds-skeleton',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="ds-skeleton" [class]="variantClass" role="status" aria-label="Cargando..."></div>`,
  styles: [`
    :host {
      --ds-skeleton-color: var(--ds-foundation-colors-neutral-200);
      --ds-skeleton-highlight-color: var(--ds-foundation-colors-neutral-100);
      --ds-skeleton-border-radius: 8px;
      --ds-skeleton-animation-duration: 1200ms;
      --ds-skeleton-title-height: 24px;
      --ds-skeleton-title-width: 200px;
      --ds-skeleton-text-height: 16px;
      --ds-skeleton-icon-size: 40px;
      --ds-skeleton-avatar-size: 48px;
      --ds-skeleton-card-height: 200px;
      --ds-skeleton-image-size: 120px;

      display: block;
    }

    @keyframes ds-skeleton-shimmer {
      0%   { background-position: -200% 0; }
      100% { background-position: 200% 0; }
    }

    .ds-skeleton {
      border-radius: var(--ds-skeleton-border-radius);
      background: linear-gradient(
        90deg,
        var(--ds-skeleton-color) 25%,
        var(--ds-skeleton-highlight-color) 50%,
        var(--ds-skeleton-color) 75%
      );
      background-size: 200% 100%;
      animation: ds-skeleton-shimmer var(--ds-skeleton-animation-duration) infinite linear;
    }

    .ds-skeleton--title {
      height: var(--ds-skeleton-title-height);
      width: var(--ds-skeleton-title-width);
    }

    .ds-skeleton--text {
      height: var(--ds-skeleton-text-height);
      width: 100%;
    }

    .ds-skeleton--card {
      height: var(--ds-skeleton-card-height);
      width: 100%;
    }

    .ds-skeleton--icon {
      height: var(--ds-skeleton-icon-size);
      width: var(--ds-skeleton-icon-size);
    }

    .ds-skeleton--avatar {
      height: var(--ds-skeleton-avatar-size);
      width: var(--ds-skeleton-avatar-size);
    }

    .ds-skeleton--image {
      height: var(--ds-skeleton-image-size);
      width: var(--ds-skeleton-image-size);
    }
  `],
})
export class DsSkeletonComponent {
  @Input() variant: DsSkeletonVariant = 'text';

  get variantClass(): string {
    return `ds-skeleton--${this.variant}`;
  }
}
